import { z } from 'zod';
import { cardStateOrderedSchema } from './CardState.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from './PartialStrictObjectSchema.ts';
import { validateState } from './ValidateState.ts';
import { EnumUtils } from '@colonist/utils';
import { createKeyRecordSchema } from './KeyRecordSchemas.ts';
import { victoryPointStateSchema } from './VictoryPointState.ts';
import { tradeRatiosStateSchema } from './TradeRatiosState.ts';
export var PlayerColor = /*#__PURE__*/ function(PlayerColor) {
    PlayerColor[PlayerColor["None"] = 0] = "None";
    PlayerColor[PlayerColor["Red"] = 1] = "Red";
    PlayerColor[PlayerColor["Blue"] = 2] = "Blue";
    PlayerColor[PlayerColor["Orange"] = 3] = "Orange";
    PlayerColor[PlayerColor["Green"] = 4] = "Green";
    PlayerColor[PlayerColor["Black"] = 5] = "Black";
    PlayerColor[PlayerColor["Bronze"] = 6] = "Bronze";
    PlayerColor[PlayerColor["Silver"] = 7] = "Silver";
    PlayerColor[PlayerColor["Gold"] = 8] = "Gold";
    PlayerColor[PlayerColor["White"] = 9] = "White";
    PlayerColor[PlayerColor["Purple"] = 10] = "Purple";
    PlayerColor[PlayerColor["MysticBlue"] = 11] = "MysticBlue";
    PlayerColor[PlayerColor["Pink"] = 12] = "Pink";
    return PlayerColor;
}({});
export const playerStateSchema = z.object({
    color: z.enum(PlayerColor).readonly(),
    victoryPointsState: victoryPointStateSchema.readonly(),
    bankTradeRatiosState: tradeRatiosStateSchema.readonly(),
    resourceCards: cardStateOrderedSchema.readonly(),
    cardDiscardLimit: z.number().int().nonnegative(),
    isTakingAction: z.boolean(),
    isConnected: z.boolean()
}).strict();
export function validatePlayerState(data) {
    return validateState(playerStateSchema, data);
}
const playerColorNumericKeys = EnumUtils.getEnumValues(PlayerColor);
export const playerStatesSchema = createKeyRecordSchema(playerColorNumericKeys, playerStateSchema);
export function validatePlayerStates(data) {
    return validateState(playerStatesSchema, data);
}
export const playerStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(playerStateSchema);
export const playerStatesPartialSchema = createKeyRecordSchema(playerColorNumericKeys, playerStatePartialSchema, {
    requireAtLeastOneEntry: true
});
